import { ApiClient } from '../../client';
import { AuditLogQueryResponse, AuditLogQueryParams } from './types';

export class AuditService {
  constructor(private api: ApiClient) {}

  async getAll(params?: AuditLogQueryParams) {
    const queryParams = new URLSearchParams();

    if (params?.advancedSearch)
      queryParams.append(
        'advancedSearch',
        JSON.stringify(params.advancedSearch)
      );
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortDirection)
      queryParams.append('sortDirection', params.sortDirection);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());
    if (params?.lastNDays)
      queryParams.append('lastNDays', params.lastNDays.toString());

    const query = queryParams.toString();
    const url = `/audit${query ? `?${query}` : ''}`;
    return this.api.get<AuditLogQueryResponse>(url);
  }
}
